<template>
  <div>
    <v-card class="text-xs-center mt-4" hover>
      <top-right-absolute>
        <v-btn flat icon color="grey" @click="edit = true" v-if="userAuthClass">
          <v-icon>edit</v-icon>
        </v-btn>
      </top-right-absolute>
      <div style="position: absolute; left: 3px; top: 3px">
        <v-btn
          flat
          icon
          :color="project.active ? 'green lighten-3' : 'red lighten-3'"
          @click="edit = true"
        >
          <v-icon v-if="project.active">check_circle</v-icon>
          <v-icon v-else>highlight_off</v-icon>
        </v-btn>
      </div>

      <div class>
        <v-avatar :color="color" size="66" class="overlap-avatar">
          <span class="white--text headline">{{letter.toUpperCase()}}</span>
        </v-avatar>
      </div>

      <router-link router :to="{ name: 'site', query: {fid: project.id} }" tag="div">
        <v-card-text>
          <div class="pb-3">
            <h5 class="subheading font-weight-regular text-capitalize">{{project.name}}</h5>
            <div class="grey--text text-capitalize">
              <span class="clickable">{{project.client.name}}</span>
            </div>
          </div>
          <div class="pb-4">
            <h5
              class="subheading font-weight-regular grey--text text--darken-1"
            >{{project.contactEmail}}</h5>
          </div>
        </v-card-text>
      </router-link>

      <!--  CARD ACTIONS -->
      <v-card-actions>
        <div class="grey--text ml-2">
          <v-btn icon flat large router :to="{ name: 'site', query: {fid: project.id} }">
            <v-badge overlap :color="$store.state.global.pages.site.color">
              <v-icon large color="grey">{{$store.state.global.pages.site.icon}}</v-icon>
              <span slot="badge">{{project.siteCount}}</span>
            </v-badge>
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-btn flat icon color="red lighten-3" @click="deleteDialog = true" v-if="userAuthClass">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-card-actions>

      <slot name="parentActions"></slot>
      <div class="card-divider grey lighten-2" style="margin-top: 0px;"></div>

      <!-- CARD FOOTER -->
      <div class="card-footer text-xs-left">
        <time-ago class="grey--text" :subject="project" :time="project.updatedAt" needsParse updated>
          <v-icon small color="grey" slot="icon" class="mr-2">access_time</v-icon>
        </time-ago>


      </div>
      <div style="width: 100%; height: 2px;" :class="color"></div>
    </v-card>

    <!--EDIT DRIVER DIALOG -->
    <v-dialog
      v-model="edit"
      max-width="700px"
      @keydown.esc="edit = false"
      lazy
      v-if="userAuthClass"
    >
      <edit-project :project="project" @close="edit = false"></edit-project>
    </v-dialog>

    <!-- DELETE CONFIRMATION DIALOG -->
    <v-dialog
      v-model="deleteDialog"
      max-width="400px"
      @keydown.esc="deleteDialog = false"
      lazy
      v-if="userAuthClass"
    >
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{project.name}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteProject(); deleteDialog = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ProjectService from "@/services/requests/projectService";
import getColorFromChar from "@/services/helpers/getColorFromChar";
import EditProject from "@/components/projects/editProject";
export default {
  data() {
    return {
      edit: false,
      deleteDialog: false
    };
  },
  methods: {
    deleteProject() {
      var project = this.project;
      ProjectService.deleteProject(project.id)
        .then(result => {
          //console.log(result.data);
          this.$store.commit("projects/deleteFromArrayStateByValue", {
            prop: "projects",
            value: project
          });
          this.snack({ text: "Project was deleted!", color: "yellow" });
        })
        .catch(err => {
          this.snackError();
        });
    }
  },
  props: {
    project: Object,
    index: Number
  },
  computed: {
    color() {
      return getColorFromChar(this.project.name.charCodeAt(0));
    },
    letter() {
      return this.project.name.charAt(0);
    }
  },
  components: {
    EditProject
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.overlap-avatar {
  margin-top: -35px;
  border: 6px solid #eee;
  border-color: #eee !important;
}
</style>
